export default __webpack_public_path__ + "images/lock.png?c147f879bfb8ba656df73c117035ad89";